export default {
  SET_INFO: (state, response) => {
    state.permissions = [];
    state.permissionsMap = {};
    for (let i = 0; i < response.data.roles.length; i++) {
      state.permissions.push(response.data.roles[i].name);
      state.permissionsMap[response.data.roles[i].name] = true;
    }
    Vue.set(state, 'user', response.data.user);
  },
};
